// NPM packages
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Path, Controller } from 'react-hook-form';
// All other imports
import { FormState } from 'hooks/useForm';
import { MembershipTier } from 'types/SignUpData';
import TierCard, {TIERS} from './TierCard';

interface TierSelectorProps<FormData extends object> {
  formState: FormState<FormData>;
  fieldName: Path<FormData>;
}

export default function TierSelector<FormData extends object>({
  formState,
  fieldName,
}: TierSelectorProps<FormData>): React.ReactElement {
  return (
    <Controller
      control={formState.control}
      name={fieldName}
      render={({ field, fieldState }) => {
        const selected = field.value as unknown as MembershipTier;
        return (
          <Box sx={{ mt: 3, mb: 2 }}>
            <Typography variant="body1" fontWeight="bold" sx={{ mb: 2 }}>
              Select a Membership Tier
            </Typography>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  md: 'repeat(3, 1fr)',
                },
                gap: 2,
                alignItems: 'stretch',
              }}
            >
              {TIERS.map((tier) => (
                <TierCard
                  key={tier.value}
                  tier={tier}
                  isSelected={selected === tier.value}
                  onSelect={(value) => field.onChange(value)}
                />
              ))}
            </Box>
            {fieldState.error && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {fieldState.error.message}
              </Typography>
            )}
          </Box>
        );
      }}
    />
  );
}